/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
const user_type = localStorage.getItem('user-type')
const base_url = '/'+ user_type
const br = document.createElement("br");

console.log(base_url, '-------------------')
export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },


  //Admin08.27
  {
    header: 'Admin',
    icon: 'PackageIcon',
    i18n: 'Admin',
    items: [
      {
        url: `${base_url}/dashboard`,
        name: 'Dashboard',
        icon: 'HomeIcon',
        i18n: 'Dashboard'
      },
      {
        url: `${base_url}/reporting`,
        name: 'Reporting',
        icon: 'TrendingUpIcon',
        i18n: 'Reporting',
        submenu: [
          {
            url: `${base_url}/reporting`,
            name: 'Number Report',
            icon: 'ListIcon',
            i18n: 'Number Report',
          },
          {
            url: `${base_url}/reporting/destination-report`,
            name: 'Destination Report',
            icon: 'NavigationIcon',
            i18n: 'Destination Report',
          },
          {
            url: null,
            name: 'Usage Report',
            icon: 'PieChartIcon',
            i18n: 'Usage Report',
          },
        ]
      },
      {
        url: `${base_url}/product`,
        name: 'Product',
        icon: 'BriefcaseIcon',
        i18n: 'Product',
      },
      {
        url: `${base_url}/balance-log`,
        name: 'Balance Log',
        icon: 'DollarSignIcon',
        i18n: 'Balance Log',
      },
      {
        url: `${base_url}/template-approval`,
        name: 'Template Approval',
        icon: 'CheckSquareIcon',
        i18n: 'Template Approval',
      },
      {
        url: `${base_url}`,
        name: 'Billing',
        icon: 'ShoppingCartIcon',
        i18n: 'Billing',
        submenu: [
          {
            url: `${base_url}/billing/invoice`,
            name: 'Invoice',
            icon: 'FileIcon',
            i18n: 'Invoice'
          },
          {
            url: `${base_url}/billing/payment`,
            name: 'Payment',
            icon: 'FileIcon',
            i18n: 'Payment'
          }
        ]
      },
      {
        url: `${base_url}/payment-term`,
        name: 'Payment Term',
        icon: 'CreditCardIcon',
        i18n: 'Payment Term',
      },
      {
        url: `${base_url}/sms-log`,
        name: 'SMS Log',
        icon: 'MailIcon',
        i18n: 'SMS Log',
      },
      {
        url: `${base_url}/ani-group`,
        name: 'ANI Group',
        icon: 'UserCheckIcon',
        i18n: 'ANI Group',
      },
      {
        url: `${base_url}/bulk-report`,
        name: 'Bulk Report',
        icon: 'FileTextIcon',
        i18n: 'Bulk Report'
      },
      {
        url: `${base_url}/reseller`,
        name: 'Resellers',
        icon: 'UserIcon',
        i18n: 'Resellers',
      },
      // {
      //   url: `${base_url}`,
      //   name: 'Invoice',
      //   icon: 'FileIcon',
      //   i18n: 'Invoice',
      //   submenu: [
      //     {
      //       url: `${base_url}/company-invoice/list`,
      //       name: 'Invoice',
      //       icon: 'FileIcon',
      //       i18n: 'Company Invoice'
      //     },
      //     {
      //       url: `${base_url}/reseller-invoice/list`,
      //       name: 'Invoice',
      //       icon: 'FileIcon',
      //       i18n: 'Reseller Invoice'
      //     }
      //   ]
      // },
      // {
      //   url: null,
      //   name: 'Payment',
      //   icon: 'CreditCardIcon',
      //   i18n: 'Payment',
      //   submenu: [
      //     {
      //       url: `${base_url}/company-payment/list`,
      //       name: 'Company Payment',
      //       icon: 'CreditCardIcon',
      //       i18n: 'Company Payment'
      //     },
      //     {
      //       url: `${base_url}/reseller-payment/list`,
      //       name: 'Reseller Payment',
      //       icon: 'CreditCardIcon',
      //       i18n: 'Reseller Payment'
      //     }
      //   ]
      // },
      {
        url: `${base_url}/usage-report`,
        name: 'Usage Report',
        icon: 'FileIcon',
        i18n: 'Usage Report',
        // submenu: [
        //   {
        //     url: `${base_url}/usage-report/inbound`,
        //     name: 'Inbound',
        //     icon: 'UserIcon',
        //     i18n: 'Inbound',
        //   },
        //   {
        //     url: `${base_url}/usage-report/outbound`,
        //     name: 'Outbound',
        //     icon: 'UserIcon',
        //     i18n: 'Outbound',
        //   }
        // ]
      },
      {
        url: `${base_url}/did`,
        name: 'DID',
        icon: 'CheckCircleIcon',
        i18n: 'DID',
        submenu: [
          {
            url: `${base_url}/did`,
            name: 'DID',
            icon: 'PhoneIcon',
            i18n: 'DID',
          },
          {
            url: `${base_url}/did/import`,
            name: 'Import Log',
            icon: 'PhoneIcon',
            i18n: 'Import Log',
          },
        ]
      },
      {
        url: `${base_url}/caller`,
        name: 'Caller ID Group',
        icon: 'PhoneIcon',
        i18n: 'Caller ID Group',
        submenu: [
          {
            url: `${base_url}/caller/import`,
            name: 'Import Log',
            icon: 'PhoneIcon',
            i18n: 'Import Log',
          },
        ]
      },
      {
        url: `${base_url}/clients`,
        name: 'Clients',
          icon: 'UsersIcon',
        i18n: 'Clients',
        submenu: [
          {
            url: `${base_url}/clients/companies`,
            name: 'Companies',
            icon: 'UserIcon',
            i18n: 'Companies',
          },
          {
            url: `${base_url}/clients/users`,
            name: 'Users',
            icon: 'UserIcon',
            i18n: 'Users',
          }
        ]
      },
      {
        url: `${base_url}/smsc-connection`,
        name: 'SMSC Connections',
        icon: 'CpuIcon',
        i18n: 'SMSC Connections',
      },
      // {
      //   url: `${base_url}/filter`,
      //   name: 'Filters',
      //   icon: 'UserIcon',
      //   i18n: 'Filters',
      // },
      {
        url: `${base_url}/vendor`,
        name: 'Vendors',
        icon: 'MessageSquareIcon',
        i18n: 'Vendors',
        submenu: [
          {
            url: `${base_url}/vendor`,
            name: 'Vendors',
            icon: 'MessageSquareIcon',
            i18n: 'Vendors',
          },
          {
            url: `${base_url}/vendor/rate-import`,
            name: 'Rate Import Log',
            icon: 'FilterIcon',
            i18n: 'Rate Import Log',
          },
        ]
      },
      {
        url: `${base_url}/filters`,
        name: 'Filters',
        icon: 'FilterIcon',
        i18n: 'Filters',
      },
      // {
      //   url: `${base_url}/rate`,
      //   name: 'Default Rate',
      //   icon: 'HelpCircleIcon',
      //   i18n: 'Default Rate'
      // }
    ]
  },
  // Company Admin
  {
    header: 'Company_Admin',
    icon: 'PackageIcon',
    i18n: 'Company Admin',
    items: [
      {
        url: '/company_admin/dashboard',
        name: 'Dashboard',
        icon: 'HomeIcon',
        i18n: 'Dashboard'
      },
      {
        url: `${base_url}/reporting`,
        name: 'Reporting',
        icon: 'TrendingUpIcon',
        i18n: 'Reporting',
        submenu: [
          {
            url: `${base_url}/reporting`,
            name: 'Number Report',
            icon: 'ListIcon',
            i18n: 'Number Report',
          },
          {
            url: `${base_url}/reporting`,/*reporting/destination-report*/
            name: 'Destination Report',
            icon: 'NavigationIcon',
            i18n: 'Destination Report',
          },
          {
            url: null,
            name: 'Usage Report',
            icon: 'PieChartIcon',
            i18n: 'Usage Report',
          },
        ]
      },

      {
        url: `/company_admin/payment_history`,
        name: 'Payment History',
        icon: 'HomeIcon',
        i18n: 'Payment History'
      },
      {
        url: `/company_admin/send_sms`,
        name: 'Send SMS',
        icon: 'MessageSquareIcon',
        i18n: 'Send SMS',
      },
      {
        url: `${base_url}`,
        name: 'Billing',
        icon: 'ShoppingCartIcon',
        i18n: 'Billing',
        submenu: [
          {
            url: `/company-admin/billing/invoice`,
            name: 'Invoice',
            icon: 'FileIcon',
            i18n: 'Invoice'
          },
          // {
          //   url: `${base_url}/billing/payment`,
          //   name: 'Payment',
          //   icon: 'FileIcon',
          //   i18n: 'Payment'
          // }
        ]
      },
      {
        url: `${base_url}/log`,
        name: 'Log',
        icon: 'PackageIcon',
        i18n: 'Log',
        submenu:[
          {
            url: `${base_url}/log/outboundsmslog`,
            name: 'Outbound',
            icon: 'FileIcon',
            i18n: 'Outbound'
          },
          {
            url: `${base_url}/log/inboundsmslog`,
            name: 'Inbound',
            icon: 'FileIcon',
            i18n: 'Inbound'
          },
          // {
          //   url: `${base_url}/template/tips`,
          //   name: 'Tips',
          //   icon: 'FileIcon',
          //   i18n: 'Tips'
          // },
          // {
          //   url: `${base_url}/template/auto`,
          //   name: 'Auto responding',
          //   icon: 'FileIcon',
          //   i18n: 'Auto responding'
          // }
        ]
      },
      {
        url: `${base_url}/report`,
        name: 'Report',
        icon: 'FileIcon',
        i18n: 'Report',
        submenu:[
          // {
          //   url: '/pages/topup',
          //   name: 'Top Up',
          //   icon: 'FileIcon',
          //   i18n: 'Top Up'
          // },
          {
            url: `/company_admin/report/outboundsmslog`,
            name: 'Outbound',
            icon: 'FileIcon',
            i18n: 'Outbound'
          },
          {
            url: `/company_admin/report/inboundsmslog`,
            name: 'Inbound',
            icon: 'FileIcon',
            i18n: 'Inbound'
          }
        ]
      },
      {
        url: `${base_url}`,
        name: 'Bulk Report',
        icon: 'GridIcon',
        i18n: 'Bulk Report',
        submenu: [
          {
            url: `${base_url}/bulk_report`,
            name: 'Bulk Report',
            icon: 'ListIcon',
            i18n: 'Bulk Report',
          },
          {
            url: `${base_url}/bulk_report`,
            name: 'Auto Substitute Bulk Report',
            icon: 'NavigationIcon',
            i18n: `Auto Substitute  Bulk Report`,
          },
          {
            url: `${base_url}/bulk_report`,
            name: 'Bulk Sms',
            icon: 'PieChartIcon',
            i18n: 'Bulk Sms',
          },
        ]
      },
      {
        url: '/pages/topup',
        name: 'Top Up',
        icon: 'FileIcon',
        i18n: 'Top Up'
      },
     /* {
        url: '/company_admin/users/users',
        name: 'Users',
        icon: 'FileIcon',
        i18n: 'Users'
      },*/
      {
        url: `/company_admin/user`,
        name: 'User',
        icon: 'FileIcon',
        i18n: 'User',
        submenu:[
          {
            url: `/company_admin/user`,
            name: 'Credits',
            icon: 'FileIcon',
            i18n: 'Credits'
          }
        ]
      },
      {
        url: `/company_admin/dids`,
        name: 'DIDs',
        icon: 'PocketIcon',
        i18n: 'DIDs',
      },
     /* {
        url: `${base_url}/ani_group`,
        name: 'ANI Group',
        icon: 'UsersIcon',
        i18n: 'ANI Group',
      },*/
    ]

  },
 //Reseller08.27
 {
  header: 'Reseller',
  icon: 'PackageIcon',
  i18n: 'Reseller',
  items: [
    {
      url: '/reseller/dashboard',
      name: 'ResellerDashboard',
      icon: 'HomeIcon',
      i18n: 'Dashboard'
    },
    {
      url: '/reseller/company',
      name: 'Companies',
      icon: 'ListIcon',
      i18n: 'Companies'
    },
    {
      url: '/reseller/user',
      name: 'Company-User',
      icon: 'UserPlusIcon',
      i18n: 'Users'
    },

    {
      url: '/reseller/anipool',
      name: 'ANI Pool',
      icon: 'CheckSquareIcon',
      i18n: 'ANI Pool'
    },

    {
      url: '/reseller/payment',
      name: 'ResellerPayment',
      icon: 'CreditCardIcon',
      i18n: 'Payment'
    },

    {
      url: '/reseller/invoice',
      name: 'Invoice',
      icon: 'FileIcon',
      i18n: 'Invoice'
    }

  ]
},
 //User portal -company admin menu 08.27
 {
   header: 'Company',
   icon: 'PackageIcon',
   i18n: 'Company',
   items: [
     {
       url: '/company/dashboard',
       name: 'Dashboard',
       icon: 'HomeIcon',
       i18n: 'Dashboard'
     },

     {
       url: '/company/chat',
       name: 'Messaging',
       icon: 'MessageSquareIcon',
       i18n: 'Messaging'
     },

     {
       url: null,
       name: 'Campaign',
       tagColor: 'primary',
       icon: 'ListIcon',
       i18n: 'Campaign',
       submenu: [
         {
           url: '/company/campaign/basic/list',
           name: 'Basic',
           i18n: 'Basic'
         },
         {
           url: '/company/campaign/conversational/list',
           name: 'Conversational',
           i18n: 'Conversational'
         },
         {
           url: '/company/campaign/p2p/list',
           name: 'Peer2Peer',
           slug: 'data-list-thumb-view',
           i18n: 'Peer2Peer'
         }
       ]
     },

     {
       url: '/company/smsworkflow',
       name: 'SMS Workflow',
       icon: 'InfoIcon',
       i18n: 'SMS Workflow'
     },

     {
       url: '/company/template',
       name: 'SMS Template',
       icon: 'SearchIcon',
       i18n: 'SMS Template'
     },

     {
       url: '/company/msgtemplate',
       name: 'Message Template',
       icon: 'ArchiveIcon',
       i18n: 'Message Template'
     },

     {
       url: '/company/tipsresponse',
       name: 'Tips Response',
       icon: 'PlusCircleIcon',
       i18n: 'Tips Response'
     },

     {
       url: '/company/callflow',
       name: 'Call Flow',
       icon: 'CalendarIcon',
       i18n: 'Call Flow'
     },

     {
       url: '/company/auto',
       name: 'Auto Responding',
       icon: 'BoldIcon',
       i18n: 'Auto Responding'
     },

     {
       url: '/company/mynum',
       name: 'My Number',
       icon: 'MonitorIcon',
       i18n: 'MyNumber'
     },

     {
       url: '/company/list',
       name: 'Contact-list',
       icon: 'FileTextIcon',
       i18n: 'ContactList'
     },
     {
       url: null,
       name: 'Analytic',
       tagColor: 'primary',
       icon: 'MoreHorizontalIcon',
       i18n: 'Analytic',
       submenu: [
         {
           url: '/company/analytic/report',
           name: 'Usage Report',
           i18n: 'Usage Report'
         },
         {
           url: '/company/analytic/smslog',
           name: 'SMS Log',
           icon: 'MailIcon',
           i18n: 'SMS Log'
         }
       ]
     },

     {
       url: '/company/numlist',
       name: 'Numbers',
       icon: 'EditIcon',
       i18n: 'Numbers'
     },

     {
       url: '/company/invoice',
       name: 'Invoice',
       icon: 'FileIcon',
       i18n: 'Invoice'
     },

     {
       url: '/company/payment',
       name: 'Payment',
       icon: 'CreditCardIcon',
       i18n: 'Payment'
     },

     {
       url: '/company/user',
       name: 'User',
       icon: 'UserIcon',
       i18n: 'User'
     }

   ]
 },

 // User portal company user menu 08.27
 {
   header: 'User',
   icon: 'PackageIcon',
   i18n: 'User',
   items: [
  /*   {
       url: '/user/dashboard',
       name: 'Dashboard',
       icon: 'HomeIcon',
       i18n: 'Dashboard'
     },*/
     {
       url:'',
       name: 'Send SMS',
       icon: 'MessageSquareIcon',
       i18n: 'Send SMS',},
     {
       url:null,
       name: 'Log',
       icon: 'PackageIcon',
       i18n: 'Log',
       submenu:[
         {
           url:'',
           name: 'Outbound',
           icon: 'FileIcon',
           i18n: 'Outbound'
         }
       ],

     },
     {
       url:`${base_url}/smsreport`,
       name: 'Report',
       icon: 'FileIcon',
       i18n: 'Report',
     /*  submenu:[
         {
           url:'',
         name: 'Outbound',
         icon: 'FileIcon',
         i18n: 'Outbound'
       }
       ],*/
     },
     {
       url:'',
       name: 'Credits',
       icon: 'CreditCardIcon',
       i18n: 'Credits'
     },
     {
       url: `${base_url}`,
       name: 'SMS Log',
       icon: 'TagIcon',
       i18n: 'SMS Log',
       submenu:[
         {
           url: `${base_url}/smslog/inbound`,
           name: 'Inbound',
           icon: 'FileIcon',
           i18n: 'Inbound'
         },
         {
           url: `${base_url}/smslog/outbound`,
           name: 'Outbound',
           icon: 'FileIcon',
           i18n: 'Outbound'
         }
       ]
     },
     {
       url: `${base_url}/bulk`,
       name: 'Bulk Report',
       icon: 'FileTextIcon',
       i18n: 'Bulk Report'
     },
     /*{
       url: `${base_url}/chat`,
       name: 'Messaging',
       icon: 'MessageSquareIcon',
       i18n: 'Messaging'
     },
     {
       url: '/user/campaign',
       name: 'Campaigns',
       icon: 'ListIcon',
       i18n: 'Campaigns'
     },
     {
       url: '/user/contact',
       name: 'Contact',
       icon: 'MonitorIcon',
       i18n: 'Contact'
     },

     {
       url: `${base_url}`,
       name: 'SMS Log',
       icon: 'TagIcon',
       i18n: 'SMS Log',
       submenu:[
          {
            url: `${base_url}/smslog/inbound`,
            name: 'Inbound',
            icon: 'FileIcon',
            i18n: 'Inbound'
          },
          {
            url: `${base_url}/smslog/outbound`,
            name: 'Outbound',
            icon: 'FileIcon',
            i18n: 'Outbound'
          }
       ]
     },
     {
       url: '/user/report',
       name: 'Report',
       icon: 'AlertCircleIcon',
       i18n: 'Report'
     },
    {
      url: `${base_url}/bulk`,
      name: 'Bulk Report',
      icon: 'FileTextIcon',
      i18n: 'Bulk Report'
    },
    {
      url: `${base_url}/smsreport`,
      name: 'SMS Report',
      icon: 'FileIcon',
      i18n: 'SMS Report'
    },*/
   ]
 },


 // Company user menu 08.27
 {
   header: 'Company User',
   icon: 'PackageIcon',
   i18n: 'Company User',
   items: [
     {
       url: 'null',
       name: 'SMS Panel',
       icon: 'DiscIcon',
       i18n: 'SMS Panel'
     },

     {
       url: '/comuser/userp2p',
       name: 'P2P Campaign',
       icon: 'BookIcon',
       i18n: 'P2P Campaign'
     },

     {
       url: '/comuser/smslog',
       name: 'SMS Log',
       icon: 'TagIcon',
       i18n: 'SMS Log'
     },
     {
       url: '/comuser/comreport',
       name: 'Report',
       icon: 'AlertCircleIcon',
       i18n: 'Report'
     }
   ]
 }
]

